'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('numberInputSecurityModalCtrl', [
    '$rootScope',
    '$scope',
    'BAS_API',
    'SECURITY',
    'BasSecurity',
    'close',
    'basModalConfig',
    'BasUtilities',
    '$timeout',
    numberInputSecurityModalCtrl
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param BAS_API
 * @param SECURITY
 * @param {BasSecurity} BasSecurity
 * @param close
 * @param {BasInputModalConfig} basInputModalConfig
 * @param {string} basInputModalConfig.title
 * @param {TBasModalInput[]} basInputModalConfig.inputs
 * @param {string} basInputModalConfig.errorTextId
 * @param {BasUtilities} BasUtilities
 * @param $timeout
 */
function numberInputSecurityModalCtrl (
  $rootScope,
  $scope,
  BAS_API,
  SECURITY,
  BasSecurity,
  close,
  basInputModalConfig,
  BasUtilities,
  $timeout
) {

  const modal = this
  const CSS_SHOW_CIRCLE_PROGRESS = 'im-show-circle-progress'
  const CSS_SHOW_CANCEL_BUTTON = 'im-show-cancel-button'
  const CSS_INPUT_INVALID = 'im-input-invalid'
  const invalidCodeErrorMessage = 'invalid_code_l1'
  const incorrectAttemptsErrorMessage = 'incorrect_attempts'

  let _listeners = []
  let updateErrorHaloTimeoutId = null
  let disableInputTimeoutId = null

  modal.closeModal = closeModal
  modal.submit = submit
  modal.enterCharacter = enterCharacter
  modal.backSpace = backSpace
  modal.clickHandler = clickHandler
  modal.cancelCountdown = cancelCountdown

  modal.basInputModalConfig = basInputModalConfig
  modal.title = basInputModalConfig.title
  modal.subTitle = basInputModalConfig.subTitle
  modal.inputValue = ''
  modal.secretInputValue = ''

  modal.progressText = BasUtilities.translate('loading')
  modal.value = basInputModalConfig.max
  modal.min = basInputModalConfig.min
  modal.max = basInputModalConfig.max
  modal.subtitle = ''
  // Step 1 = keycode, Step 2 = countdown
  modal.step = 1
  modal.showCircleProgress = modal.basInputModalConfig.showCircleProgress
  modal.showErrorHalo = false
  modal.css = {}
  modal.inputDisabled = false
  modal.showLoadingState = false

  let loadingTimeoutId = null

  init()

  function init () {
    $scope.$on('$destroy', _onDestroy)
    _listeners.push($rootScope.$on(
      SECURITY.EVT_COUNTDOWN_UPDATED,
      _onCountdownUpdate
    ))
    _listeners.push($rootScope.$on(
      SECURITY.EVT_FORCE_CLOSE_COUNTDOWN_MODAL,
      _onForceClose
    ))

    _resetCss()

    _initInput()
    _onInputChanged()

    if (BasSecurity.isLockedOut()) {
      const remaining = BasSecurity.getLockoutRemaining()
      _applyLockoutUI(remaining)
    } else {
      modal.inputDisabled = false
    }
  }

  function _initInput () {

    if (
      Array.isArray(basInputModalConfig.inputs) &&
      basInputModalConfig.inputs[0]
    ) {

      const input = basInputModalConfig.inputs[0]

      modal.inputValue = BasUtil.isNEString(input.initialValue)
        ? input.initialValue
        : ''
    }
  }

  function _onInputChanged () {
    _syncValid()
    const inputLenght = (modal.inputValue || '').length
    if (inputLenght < 4 && modal.showErrorHalo) {
      modal.showErrorHalo = false
      modal.uiError = ''
    }
    if (inputLenght === 4) {
      submit()
    }
  }

  function _syncValid () {
    modal.css[CSS_INPUT_INVALID] =
    modal.inputValue.length !== modal.basInputModalConfig.inputs[0]?.length
  }

  function closeModal (reason) {

    if (
      !modal.basInputModalConfig ||
      modal.basInputModalConfig.allowDismiss
    ) {

      close(reason)
    }
  }

  function submit () {
    if (modal.inputValue.length === 0) {
      _updateErrorHalo()
      return
    }
    if (modal.showCircleProgress) {
      startCountdown()
    } else {
      BasSecurity.disarm(modal.inputValue)
        .then(() => {
          closeModal()
        })
        .catch(_handleSecurityError)
    }
  }

  function enterCharacter (character) {
    if (modal.inputDisabled) return
    modal.inputValue = `${modal.inputValue}${character}`.slice(0, modal.basInputModalConfig.inputs[0].length)
    _onInputChanged()
  }

  function backSpace () {
    if (modal.inputDisabled) return
    modal.inputValue = modal.inputValue.slice(0, modal.inputValue.length - 1)
  }

  function startCountdown () {
    modal.showLoadingState = true
    BasSecurity.arm(modal.inputValue)
      .then(() => {
        modal.css[CSS_SHOW_CIRCLE_PROGRESS] = true
        modal.css[CSS_SHOW_CANCEL_BUTTON] = true
        modal.step = 2
        $scope.$applyAsync()

        _startLoadingTimeout()
      })
      .catch(_handleSecurityError)
  }

  function cancelCountdown () {
    BasSecurity.cancelCountdown(modal.inputValue)
    closeModal()
  }

  function _handleSecurityError (err) {
    let disabled = false
    if (
      err &&
      err.message &&
      err.message.error &&
      err.message.error.code
    ) {
      switch (err.message.error.code) {
        case BAS_API.CONSTANTS.INVALID_CODE:
          modal.uiError = invalidCodeErrorMessage
          break
        case BAS_API.CONSTANTS.TOO_MANY_ATTEMPTS:
          modal.uiError = incorrectAttemptsErrorMessage
          disabled = true
          break
      }
    }
    modal.showErrorHalo = true

    $timeout(function () {
      modal.inputValue = ''
    }, 100)

    if (disabled) {
      const duration = BasSecurity.getLockoutDuration()
      BasSecurity.startLockout(duration)
      _applyLockoutUI(duration)
    } else {
      modal.inputDisabled = false
    }
  }

  function clickHandler () {
    modal.step === 1 ? submit() : cancelCountdown()
  }

  function _onCountdownUpdate (_, countdown) {

    modal.showLoadingState = false
    _startLoadingTimeout()

    modal.subtitle = BasUtilities.translate('arming_the_alarm')

    if (countdown < modal.min) {

      closeModal()

    } else {
      // +1 => Make text synced with transition duration: 1s of progress bar
      modal.progressText = countdown + 1
      modal.value = countdown
    }

    $scope.$applyAsync()
  }

  function _onForceClose () {
    closeModal()
  }

  /**
   * Update showErrorHalo variable instantly
   *
   * @private
   */
  function _updateErrorHalo () {

    _clearErrorHaloTimeout()

    modal.showErrorHalo = modal.inputValue.length === 0
    _syncErrorText()

    $scope.$applyAsync()
  }

  function _clearErrorHaloTimeout () {

    clearTimeout(updateErrorHaloTimeoutId)
    updateErrorHaloTimeoutId = null
  }

  function _syncErrorText () {

    if (modal.inputValue.length === 0) {

      modal.uiError = BasUtilities.translate('please_fill_in_keycode')
    }
  }

  function _resetCss () {

    modal.css[CSS_SHOW_CIRCLE_PROGRESS] = false
    modal.css[CSS_SHOW_CANCEL_BUTTON] = false
    modal.css[CSS_INPUT_INVALID] = false
  }

  function _onDestroy () {

    BasUtil.executeArray(_listeners)
    _listeners = []

    _clearLoadingTimeout()
    disableInputTimeoutId = null
  }

  function _startLoadingTimeout () {

    _clearLoadingTimeout()

    loadingTimeoutId = setTimeout(() => {
      closeModal()
    }, basInputModalConfig.max * 1000)
  }

  function _clearLoadingTimeout () {
    if (loadingTimeoutId) {
      clearTimeout(loadingTimeoutId)
      loadingTimeoutId = null
    }
  }

  function _applyLockoutUI (durationMs) {
    modal.inputDisabled = true
    modal.showErrorHalo = true
    modal.uiError = incorrectAttemptsErrorMessage
    $scope.$applyAsync()

    if (disableInputTimeoutId) {
      clearTimeout(disableInputTimeoutId)
    }

    disableInputTimeoutId = setTimeout(function () {
      modal.inputDisabled = false
      modal.uiError = ''
      modal.showErrorHalo = false
      $scope.$applyAsync()
    }, durationMs)
  }
}
